// extracted by mini-css-extract-plugin
export default {"sectionThree":"SectionThree_sectionThree__tvG53","titleSectionThree":"SectionThree_titleSectionThree__GJZNE","cards":"SectionThree_cards__67Uff"};